export type UserRole = 'tm_admin' | 'district_champion' | 'school_champion';

export const ROLE_HIERARCHY = {
  tm_admin: 3,
  district_champion: 2,
  school_champion: 1
} as const;

export interface MenuFilterConfig {
  hideItems: string[];
  hideSubItems: Record<string, string[]>;
}

export interface RouteConfig {
  allowedRoles?: UserRole[];
  allowedEmails?: string[];
  fallback: string;
}

export const ROLE_MENU_CONFIG: Record<UserRole, MenuFilterConfig> = {
  tm_admin: {
    hideItems: ['groupAdmin.title'],
    hideSubItems: {}
  },
  district_champion: {
    hideItems: ['groupAdmin.title', 'terraceMetricsAdmin.title'],
    hideSubItems: {
      // 'assessment.title': ['assessment.combinedReport']
    }
  },
  school_champion: {
    hideItems: ['organizationAdmin.title', 'terraceMetricsAdmin.title'],
    hideSubItems: {
      // 'assessment.title': ['assessment.combinedReport']
    }
  }
};

export const RBAC_CONFIG = {
  routes: {
    '/assessment/combined-report': {
      allowedRoles: ['tm_admin', 'district_champion', 'school_champion'] as UserRole[],
      allowedEmails: [],
      // allowedEmails: ['rebecca.strouse@campbell.kyschools.us', 'hang.ung@m4x.org', 'robertson.m@dpccsd.org', 'jamee.flaherty@fortthomas.kyschools.us'],
      fallback: '/dashboard'
    } as RouteConfig,
    '/admin/users': {
      allowedRoles: ['tm_admin'] as UserRole[],
      fallback: '/dashboard'
    } as RouteConfig,
    '/admin/indicators': {
      allowedRoles: ['tm_admin'] as UserRole[],
      fallback: '/dashboard'
    } as RouteConfig,
    '/organization/list': {
      allowedRoles: ['tm_admin'] as UserRole[],
      fallback: '/dashboard'
    } as RouteConfig,
    '/organization/create': {
      allowedRoles: ['tm_admin'] as UserRole[],
      fallback: '/dashboard'
    } as RouteConfig,
    '/organization/update': {
      allowedRoles: ['tm_admin', 'district_champion', 'school_champion'] as UserRole[],
      fallback: '/dashboard'
    } as RouteConfig,
    '/organization/manage-champions': {
      allowedRoles: ['tm_admin', 'district_champion', 'school_champion'] as UserRole[],
      fallback: '/dashboard'
    } as RouteConfig
  },
  features: {
    combinedReport: ['tm_admin', 'district_champion', 'school_champion'] as UserRole[],
    userManagement: ['tm_admin'] as UserRole[],
    indicatorManagement: ['tm_admin'] as UserRole[],
    organizationCreate: ['tm_admin'] as UserRole[],
    organizationEdit: ['tm_admin', 'district_champion', 'school_champion'] as UserRole[],
    groupManagement: ['tm_admin', 'district_champion'] as UserRole[]
  }
};

// Helper functions
export const hasRole = (userRole: string | null, allowedRoles: UserRole[]): boolean => {
  return userRole ? allowedRoles.includes(userRole as UserRole) : false;
};

export const hasMinRoleLevel = (userRole: string | null, minLevel: number): boolean => {
  if (!userRole || !(userRole in ROLE_HIERARCHY)) return false;
  return ROLE_HIERARCHY[userRole as UserRole] >= minLevel;
};

export const hasEmailAccess = (userEmail: string | undefined, allowedEmails: string[]): boolean => {
  if (!userEmail || allowedEmails.length === 0) return false;
  return allowedEmails.includes(userEmail);
};

export const getRouteConfig = (path: string): RouteConfig | undefined => {
  return RBAC_CONFIG.routes[path as keyof typeof RBAC_CONFIG.routes];
};

export const hasFeatureAccess = (userRole: string | null, feature: keyof typeof RBAC_CONFIG.features): boolean => {
  return hasRole(userRole, RBAC_CONFIG.features[feature]);
};